module.exports = __webpack_public_path__ + "static/media/Ubuntu-Bold.e00e2a77.ttf";